import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const updateSecondHandSuppliesByPkMutation = gql`mutation update_second_hand_supplies_by_pk($id:uuid!,$second_hand_supply: second_hand_supplies_set_input ){
  update_second_hand_supplies_by_pk(pk_columns:{id: $id}, _set: $second_hand_supply){
    id
  }
}`
@Injectable({
  providedIn: 'root'
})
export class UpdateSecondHandSupplyService {

  constructor(private apollo: Apollo) { }

  updateSecondHandSupplyByPk(id: string, second_hand_supply: any){
    return this.apollo.use('external').mutate({
      mutation: updateSecondHandSuppliesByPkMutation,
      variables: {
        id,
        second_hand_supply
      }
    }).pipe(pluck('data', 'update_second_hand_supplies_by_pk', 'id')).toPromise();
  }
}
